import Story1 from "./Story1";

const stories = {
    1: Story1
};

export default stories;